var _a = require('./utils'), isEmptyObj = _a.isEmptyObj, CurrencyFormat = _a.CurrencyFormat;
var FORMATTER = require('../const/messenger').FORMATTER;
var getTelegramContact = require('../helpers/messenger').getTelegramContact;
var _b = require('../helpers/auth'), getUserRoles = _b.getUserRoles, hasRole = _b.hasRole, isRole = _b.isRole;
export function getPartnerDetails(page, breadcrumbs) {
    var node;
    var uri;
    if (!page || !breadcrumbs)
        return null;
    if (page === null || page === void 0 ? void 0 : page.partner) {
        return {
            uri: page._uri,
            node: page
        };
    }
    Object.keys(breadcrumbs).map(function (i) {
        var _a;
        if (!isEmptyObj(node))
            return false;
        if ((_a = breadcrumbs[i]) === null || _a === void 0 ? void 0 : _a.partner) {
            node = breadcrumbs[i];
            uri = i;
        }
    });
    return { uri: uri, node: node };
}
export function orderTitle(formatter, data, config) {
    var title;
    if (formatter === FORMATTER.EXCHANGE) {
        title = ExchangeOrderTitleText(data, config, false, true);
    }
    else if (formatter === FORMATTER.NETWORKING) {
        title = NetworkingOrderTitleText(data);
    }
    else {
        title = OrderTitleText(data === null || data === void 0 ? void 0 : data.order);
    }
    return title;
}
export function getExchangeMessage(partnerFormConfig, orderData, oid, cid) {
    var _a, _b, _c, _d;
    var template = {};
    if ((_b = (_a = orderData === null || orderData === void 0 ? void 0 : orderData.data) === null || _a === void 0 ? void 0 : _a.messenger) === null || _b === void 0 ? void 0 : _b.telegram) {
        template = getExchangeTelegramMessageOptions(partnerFormConfig, orderData, oid, cid);
    }
    else if ((_d = (_c = orderData === null || orderData === void 0 ? void 0 : orderData.data) === null || _c === void 0 ? void 0 : _c.messenger) === null || _d === void 0 ? void 0 : _d.whatsapp) {
        template = getExchangeWhatsAppMessageOptions(partnerFormConfig, orderData, oid, cid);
    }
    else {
        template = getExchangeTextMessageOptions(partnerFormConfig, orderData, oid, cid);
    }
    return getExchangeMessageFormat(template, partnerFormConfig, orderData, cid);
}
export function getExchangeTextMessage(partnerFormConfig, orderData, oid, cid) {
    var template = getExchangeTextMessageOptions(partnerFormConfig, orderData, oid, cid);
    return getExchangeMessageFormat(template, partnerFormConfig, orderData, cid);
}
export function getExchangeWebMessage(partnerFormConfig, orderData, oid, cid) {
    var template = getExchangeWebMessageOptions(partnerFormConfig, orderData, oid, cid);
    return getExchangeWebMessageFormat(template, partnerFormConfig, orderData, cid);
}
export function getExchangeWhatsAppMessage(partnerFormConfig, orderData, oid, cid) {
    var template = getExchangeWhatsAppMessageOptions(partnerFormConfig, orderData, oid, cid);
    return getExchangeMessageFormat(template, partnerFormConfig, orderData, cid);
}
export function getExchangeTelegramMessage(partnerFormConfig, orderData, oid, cid) {
    var template = getExchangeTelegramMessageOptions(partnerFormConfig, orderData, oid, cid);
    return getExchangeMessageFormat(template, partnerFormConfig, orderData, cid);
}
export function getExchangeMessageFormat(template, partnerFormConfig, orderData, cid) {
    if (!partnerFormConfig || !orderData)
        return '';
    var result = "".concat(template.hello, "\n\n").concat(template.header, "\n").concat(template.order, "\n\n").concat(template.check);
    return result;
}
export function getExchangeWebMessageFormat(template, partnerFormConfig, orderData, cid) {
    if (!partnerFormConfig || !orderData)
        return '';
    var result = "".concat(template.hello, "<br />\n<br />\n").concat(template.header, "<br />\n").concat(template.order, "<br />\n<br />\n").concat(template.check);
    {
    }
    return result;
}
function getExchangeWebMessageOptions(partnerFormConfig, orderData, oid, cid) {
    if (!partnerFormConfig || !orderData)
        return {};
    var hello = "\uD83D\uDCB8 \u0412\u0456\u0442\u0430\u0454\u043C\u043E! \u0412\u0438 \u0437\u0440\u043E\u0431\u0438\u043B\u0438 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 https://".concat(orderData._city, ".miy-prostir.online/");
    var did;
    if (partnerFormConfig.links[orderData._city]._did) {
        did = partnerFormConfig.links[orderData._city]._did;
    }
    else {
        did = partnerFormConfig.links[orderData._city];
    }
    var link = "https://".concat(orderData._city, ".miy-prostir.online/?goToDid=").concat(orderData._city, ":").concat(did);
    var type = orderData.form ? 'form' : orderData.shop ? 'shop' : '-';
    var check = "\uD83D\uDD0E \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0438\u0442\u0438 \u0437\u0430\u044F\u0432\u043A\u0443:\n<br>\nhttps://".concat(orderData._city, ".miy-prostir.online/?checkOrder=").concat(type, ":").concat(orderData.partner, ":").concat(oid, "\n<br>\n<i>* \u0446\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043C\u043E\u0436\u0435 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043B\u0438\u0448\u0435 \u0437\u0430\u043C\u043E\u0432\u043D\u0438\u043A \u0442\u0430 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u0441\u0435\u0440\u0432\u0456\u0441\u0443</i>");
    var title = orderTitle(orderData.formatter, orderData === null || orderData === void 0 ? void 0 : orderData.data, partnerFormConfig);
    var header = "<b>".concat(partnerFormConfig.title, ": ").concat(title, "</b>");
    var order = "<i>\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u044F\u0432\u043A\u0438: ".concat(oid, "</i>");
    var result = { hello: hello, link: link, check: check, header: header, order: order };
    return result;
}
function getExchangeTextMessageOptions(partnerFormConfig, orderData, oid, cid) {
    if (!partnerFormConfig || !orderData)
        return {};
    var hello = "\uD83D\uDCB8 \u0412\u0456\u0442\u0430\u0454\u043C\u043E! \u0412\u0438 \u0437\u0440\u043E\u0431\u0438\u043B\u0438 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 https://".concat(orderData._city, ".miy-prostir.online/");
    var did;
    if (partnerFormConfig.links[orderData._city]._did) {
        did = partnerFormConfig.links[orderData._city]._did;
    }
    else {
        did = partnerFormConfig.links[orderData._city];
    }
    var link = "https://".concat(orderData._city, ".miy-prostir.online/?goToDid=").concat(orderData._city, ":").concat(did);
    var type = orderData.form ? 'form' : orderData.shop ? 'shop' : '-';
    var check = "\uD83D\uDD0E \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0438\u0442\u0438 \u0437\u0430\u044F\u0432\u043A\u0443:\nhttps://".concat(orderData._city, ".miy-prostir.online/?checkOrder=").concat(type, ":").concat(orderData.partner, ":").concat(oid, "\n* \u0446\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043C\u043E\u0436\u0435 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043B\u0438\u0448\u0435 \u0437\u0430\u043C\u043E\u0432\u043D\u0438\u043A \u0442\u0430 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u0441\u0435\u0440\u0432\u0456\u0441\u0443");
    var title = orderTitle(orderData.formatter, orderData === null || orderData === void 0 ? void 0 : orderData.data, partnerFormConfig);
    var header = "".concat(partnerFormConfig.title, ": ").concat(title);
    var order = "\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u044F\u0432\u043A\u0438: ".concat(oid);
    var result = { hello: hello, link: link, check: check, header: header, order: order };
    return result;
}
function getExchangeWhatsAppMessageOptions(partnerFormConfig, orderData, oid, cid) {
    if (!partnerFormConfig || !orderData)
        return {};
    var hello = "\u0412\u0456\u0442\u0430\u0454\u043C\u043E! \u0412\u0438 \u0437\u0440\u043E\u0431\u0438\u043B\u0438 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u043D\u0430 \u0441\u0430\u0439\u0442\u0456 https://".concat(orderData._city, ".miy-prostir.online/");
    var did;
    if (partnerFormConfig.links[orderData._city]._did) {
        did = partnerFormConfig.links[orderData._city]._did;
    }
    else {
        did = partnerFormConfig.links[orderData._city];
    }
    var link = "https://".concat(orderData._city, ".miy-prostir.online/?goToDid=").concat(orderData._city, ":").concat(did);
    var type = orderData.form ? 'form' : orderData.shop ? 'shop' : '-';
    var check = "\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0438\u0442\u0438 \u0437\u0430\u044F\u0432\u043A\u0443:\nhttps://".concat(orderData._city, ".miy-prostir.online/?checkOrder=").concat(type, ":").concat(orderData.partner, ":").concat(oid, "\n* \u0446\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043C\u043E\u0436\u0435 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043B\u0438\u0448\u0435 \u0437\u0430\u043C\u043E\u0432\u043D\u0438\u043A \u0442\u0430 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u0441\u0435\u0440\u0432\u0456\u0441\u0443");
    var title = orderTitle(orderData.formatter, orderData === null || orderData === void 0 ? void 0 : orderData.data, partnerFormConfig);
    var header = "*".concat(partnerFormConfig.title, ": ").concat(title, "*");
    var order = "_\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u044F\u0432\u043A\u0438: ".concat(oid, "_");
    var result = { hello: hello, link: link, check: check, header: header, order: order };
    return result;
}
function getExchangeTelegramMessageOptions(partnerFormConfig, orderData, oid, cid) {
    if (!partnerFormConfig || !orderData)
        return {};
    var hello = "\uD83D\uDCB8 \u0412\u0456\u0442\u0430\u0454\u043C\u043E! \u0412\u0438 \u0437\u0440\u043E\u0431\u0438\u043B\u0438 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0432 \u0431\u043E\u0442\u0456 @MiyProstirBot";
    var did;
    if (partnerFormConfig.links[orderData._city]._did) {
        did = partnerFormConfig.links[orderData._city]._did;
    }
    else {
        did = partnerFormConfig.links[orderData._city];
    }
    var link = "https://t.me/MiyProstirBot/?startapp=goToDid---".concat(orderData._city, "___").concat(did);
    var type = orderData.form ? 'form' : orderData.shop ? 'shop' : '-';
    var check = "\uD83D\uDD0E \u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0438\u0442\u0438 \u0437\u0430\u044F\u0432\u043A\u0443:\nhttps://t.me/MiyProstirBot/?startapp=checkOrder---".concat(type, "___").concat(orderData.partner, "___").concat(oid, "\n* \u0446\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043C\u043E\u0436\u0435 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043B\u0438\u0448\u0435 \u0437\u0430\u043C\u043E\u0432\u043D\u0438\u043A \u0442\u0430 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u0441\u0435\u0440\u0432\u0456\u0441\u0443");
    var title = orderTitle(orderData.formatter, orderData === null || orderData === void 0 ? void 0 : orderData.data, partnerFormConfig);
    var header = "**".concat(partnerFormConfig.title, ": ").concat(title, "**");
    var order = "__\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u044F\u0432\u043A\u0438: ".concat(oid, "__");
    var result = { hello: hello, link: link, check: check, header: header, order: order };
    return result;
}
export function getExchangeUrl(data, message) {
    var _a, _b;
    if ((_a = data === null || data === void 0 ? void 0 : data.messenger) === null || _a === void 0 ? void 0 : _a.telegram) {
        return getExchangeTelegramUrl(data, message);
    }
    else if ((_b = data === null || data === void 0 ? void 0 : data.messenger) === null || _b === void 0 ? void 0 : _b.whatsapp) {
        return getExchangeWhatsAppUrl(data, message);
    }
    return false;
}
export function getExchangeTelegramUrl(data, message) {
    var _a;
    var tid = getTelegramContact((_a = data === null || data === void 0 ? void 0 : data.messenger) === null || _a === void 0 ? void 0 : _a.telegram);
    if (tid) {
        return "https://t.me/".concat(tid, "?text=").concat(message);
    }
    return false;
}
export function getExchangeWhatsAppUrl(data, message) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var wid;
    if ((_b = (_a = data === null || data === void 0 ? void 0 : data.messenger) === null || _a === void 0 ? void 0 : _a.whatsapp) === null || _b === void 0 ? void 0 : _b.phone) {
        wid = ((_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.messenger) === null || _c === void 0 ? void 0 : _c.whatsapp) === null || _d === void 0 ? void 0 : _d.phone) === null || _e === void 0 ? void 0 : _e.code) + ((_h = (_g = (_f = data === null || data === void 0 ? void 0 : data.messenger) === null || _f === void 0 ? void 0 : _f.whatsapp) === null || _g === void 0 ? void 0 : _g.phone) === null || _h === void 0 ? void 0 : _h.number);
    }
    if (wid) {
        return "https://wa.me/".concat(wid, "?text=").concat(message);
    }
    return false;
}
export function getExchangeBotMessage(partnerFormConfig, orderData, oid, userHasBot) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    if (!partnerFormConfig || !orderData)
        return '';
    var title = orderTitle(orderData.formatter, orderData === null || orderData === void 0 ? void 0 : orderData.data, partnerFormConfig);
    var contact;
    if ((_b = (_a = orderData === null || orderData === void 0 ? void 0 : orderData.data) === null || _a === void 0 ? void 0 : _a.messenger) === null || _b === void 0 ? void 0 : _b.telegram) {
        contact = "\u0422\u0435\u043B\u0435\u0433\u0440\u0430\u043C \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0430\u043C\u0438: ".concat(getTelegramContact((_d = (_c = orderData === null || orderData === void 0 ? void 0 : orderData.data) === null || _c === void 0 ? void 0 : _c.messenger) === null || _d === void 0 ? void 0 : _d.telegram));
    }
    else if ((_f = (_e = orderData === null || orderData === void 0 ? void 0 : orderData.data) === null || _e === void 0 ? void 0 : _e.messenger) === null || _f === void 0 ? void 0 : _f.whatsapp) {
        contact = "WhatsApp \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0430\u043C\u0438: ".concat((_k = (_j = (_h = (_g = orderData === null || orderData === void 0 ? void 0 : orderData.data) === null || _g === void 0 ? void 0 : _g.messenger) === null || _h === void 0 ? void 0 : _h.whatsapp) === null || _j === void 0 ? void 0 : _j.phone) === null || _k === void 0 ? void 0 : _k.code).concat((_p = (_o = (_m = (_l = orderData === null || orderData === void 0 ? void 0 : orderData.data) === null || _l === void 0 ? void 0 : _l.messenger) === null || _m === void 0 ? void 0 : _m.whatsapp) === null || _o === void 0 ? void 0 : _o.phone) === null || _p === void 0 ? void 0 : _p.number);
    }
    else {
        contact = 'контактами ';
    }
    var type = orderData.form ? 'form' : orderData.shop ? 'shop' : '-';
    var check;
    if (userHasBot)
        check = "https://t.me/MiyProstirBot/?startapp=checkOrder---".concat(type, "___").concat(orderData.partner, "___").concat(oid);
    else
        check = "https://".concat(orderData._city, ".miy-prostir.online/?checkOrder=").concat(type, ":").concat(orderData.partner, ":").concat(oid);
    var result = "\uD83D\uDCB8 \u0412\u0456\u0442\u0430\u0454\u043C\u043E! \u0412\u0438 \u0437\u0440\u043E\u0431\u0438\u043B\u0438 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F \u0432 @MiyProstirBot<br>\n<br>\n<b>".concat(partnerFormConfig.title, ": ").concat(title, "</b>\n<i>\u041D\u043E\u043C\u0435\u0440 \u0437\u0430\u044F\u0432\u043A\u0438: ").concat(oid, "</i>\n<br>\n<br>\n");
    result += "\u26A0\uFE0F \u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u0441\u0435\u0440\u0432\u0456\u0441\u0443 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0437\u0432\u02BC\u044F\u0437\u0430\u0442\u0438\u0441\u044C \u0437 \u0432\u0430\u043C\u0438 \u0437\u0430 \u0432\u043A\u0430\u0437\u0430\u043D\u0438\u043C\u0438 ".concat(contact, "<br>\n<br>\n\uD83D\uDCAC \u041D\u0430\u043F\u0438\u0448\u0456\u0442\u044C \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0443 \u0441\u0435\u0440\u0432\u0456\u0441\u0443 @").concat(partnerFormConfig.manager.tid, ", \u0434\u043B\u044F \u0443\u0442\u043E\u0447\u043D\u0435\u043D\u043D\u044F \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0437\u0430\u043C\u043E\u0432\u043B\u0435\u043D\u043D\u044F<br>\n<br>\n\u2611\uFE0F <a href=\"").concat(check, "\">\u041F\u0435\u0440\u0435\u0432\u0456\u0440\u0438\u0442\u0438 \u0437\u0430\u044F\u0432\u043A\u0443</a>\n<br>\n<i>* \u0446\u0435 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u043C\u043E\u0436\u0435 \u0432\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u043B\u0438\u0448\u0435 \u0437\u0430\u043C\u043E\u0432\u043D\u0438\u043A \u0442\u0430 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440 \u0441\u0435\u0440\u0432\u0456\u0441\u0443</i>");
    return result;
}
export function ExchangeOrderTitleText(data, config, lowCase, short, pre) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var amount = data.amount;
    var currency = data.currency;
    if (!amount
        || ((!currency && !data['crypto-currency'])))
        return 'Відсутні параметри заявки';
    var from = '';
    if (((_a = config === null || config === void 0 ? void 0 : config.form) === null || _a === void 0 ? void 0 : _a.confirm) === "exchange-bill-payment-summary" || ((_b = config === null || config === void 0 ? void 0 : config.form) === null || _b === void 0 ? void 0 : _b.confirm) === "exchange-bill-payment-atm") {
        from = CurrencyFormat(amount, 'idr');
    }
    else if (data['currency'] || data['currency-ukraine-card']) {
        var currency_1 = data['currency'];
        if ((currency_1 === null || currency_1 === void 0 ? void 0 : currency_1.value) && (currency_1 === null || currency_1 === void 0 ? void 0 : currency_1.value) === "_else") {
            from = "".concat(amount, " ").concat(currency_1.else);
        }
        else {
            from = CurrencyFormat(amount, ((currency_1 === null || currency_1 === void 0 ? void 0 : currency_1.value) || currency_1));
        }
    }
    else if (data['crypto-currency']) {
        if (((_c = data['crypto-currency']) === null || _c === void 0 ? void 0 : _c.value) && ((_d = data['crypto-currency']) === null || _d === void 0 ? void 0 : _d.value) === "_else") {
            from = "".concat(amount, " ").concat(data['crypto-currency'].else);
        }
        else {
            from = "".concat(amount, " ").concat((((_e = data['crypto-currency']) === null || _e === void 0 ? void 0 : _e.value) || data['crypto-currency']).toUpperCase());
        }
    }
    var to = '';
    if (data['outcome-currency']) {
        if (((_f = data['outcome-currency']) === null || _f === void 0 ? void 0 : _f.value) && ((_g = data['outcome-currency']) === null || _g === void 0 ? void 0 : _g.value) === "_else") {
            to = data['outcome-currency'].else;
        }
        else {
            to = CurrencyFormat(0, ((_h = data['outcome-currency']) === null || _h === void 0 ? void 0 : _h.value) || data['outcome-currency']).substring(2);
        }
    }
    else if (data['outcome-crypto']) {
        if (((_j = data['outcome-crypto']) === null || _j === void 0 ? void 0 : _j.value) && ((_k = data['outcome-crypto']) === null || _k === void 0 ? void 0 : _k.value) === "_else") {
            to = data['outcome-crypto'].else;
        }
        else {
            to = (((_l = data['outcome-crypto']) === null || _l === void 0 ? void 0 : _l.value) || data['outcome-crypto']).toUpperCase();
        }
    }
    var msg = from;
    if (!short && to)
        msg = "".concat(from, " => ").concat(to);
    if (msg && lowCase) {
        msg = msg[0].toLowerCase() + msg.substring(1);
    }
    if (pre && msg)
        msg = pre + " " + msg;
    return msg;
}
export function NetworkingOrderTitleText(order, attachText, pre) {
    var title = (order === null || order === void 0 ? void 0 : order.title) || '';
    return title;
}
export function OrderTitleText(order) {
    var title = order === null || order === void 0 ? void 0 : order.map(function (item) { var _a; return (_a = item === null || item === void 0 ? void 0 : item.details) === null || _a === void 0 ? void 0 : _a.title; }).join(', ');
    return title;
}
export function isManager(user, partnerConfig) {
    var _a;
    if (!(user === null || user === void 0 ? void 0 : user.id))
        return false;
    if (!((_a = partnerConfig === null || partnerConfig === void 0 ? void 0 : partnerConfig.manager) === null || _a === void 0 ? void 0 : _a.pid))
        return false;
    if (isRole(partnerConfig.manager.pid)) {
        if (hasRole([partnerConfig.manager.pid], getUserRoles(user))) {
            return true;
        }
    }
    else {
        if (partnerConfig.manager.pid === user.id) {
            return true;
        }
    }
    return false;
}
